module.exports = __webpack_public_path__ + "img/2.504acf9f.png";